var map = {
	"./deal-review/pages/new-version/tabs/Staffing/Staffing": [
		39872,
		6321,
		894,
		9300,
		768,
		8839,
		5443,
		3085,
		5702,
		2954,
		1192,
		6738,
		9887,
		7000,
		8570,
		3913,
		822,
		1104,
		3314
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1626;
module.exports = webpackAsyncContext;